declare namespace $ {

	type $mol_button_minor__click_shm_hitalama_components_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['add_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_components_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_components_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__event_shm_hitalama_components_4 = $mol_type_enforce<
		({ 
			mouseenter( next?: ReturnType< $shm_hitalama_components['add_enter'] > ): ReturnType< $shm_hitalama_components['add_enter'] >,
			keydown( next?: ReturnType< $shm_hitalama_components['add_keydown'] > ): ReturnType< $shm_hitalama_components['add_keydown'] >,
		})  & ReturnType< $mol_pop_over['event'] >
		,
		ReturnType< $mol_pop_over['event'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_components_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Add_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_components_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['add_content'] >
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $shm_hitalama_components_drag__catalog_shm_hitalama_components_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['catalog'] >
		,
		ReturnType< $shm_hitalama_components_drag['catalog'] >
	>
	type $shm_hitalama_components_drag__locked_shm_hitalama_components_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['drag_locked'] >
		,
		ReturnType< $shm_hitalama_components_drag['locked'] >
	>
	type $shm_hitalama_components_drag__reversed_shm_hitalama_components_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['drag_reversed'] >
		,
		ReturnType< $shm_hitalama_components_drag['reversed'] >
	>
	type $shm_hitalama_components_drag__roots_shm_hitalama_components_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['roots'] >
		,
		ReturnType< $shm_hitalama_components_drag['roots'] >
	>
	type $shm_hitalama_components_drag__children_shm_hitalama_components_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['children'] >
		,
		ReturnType< $shm_hitalama_components_drag['children'] >
	>
	type $shm_hitalama_components_drag__expanded_shm_hitalama_components_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['expanded'] >
		,
		ReturnType< $shm_hitalama_components_drag['expanded'] >
	>
	type $shm_hitalama_components_drag__Item_shm_hitalama_components_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['item'] >
		,
		ReturnType< $shm_hitalama_components_drag['Item'] >
	>
	type $shm_list_page__title_shm_hitalama_components_14 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_page['title'] >
	>
	type $shm_list_page__minimal_width_shm_hitalama_components_15 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_list_page['minimal_width'] >
	>
	type $shm_list_page__filter_shm_hitalama_components_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['query'] >
		,
		ReturnType< $shm_list_page['filter'] >
	>
	type $shm_list_page__sort_order_shm_hitalama_components_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['sort_order'] >
		,
		ReturnType< $shm_list_page['sort_order'] >
	>
	type $shm_list_page__add_content_shm_hitalama_components_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_page['add_content'] >
	>
	type $shm_list_page__body_shm_hitalama_components_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_page['body'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['add_application'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_components_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['add_group'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_components_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_string__hint_shm_hitalama_components_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['new_name_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_components_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['new_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_components_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['folder_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_components_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['new_parent'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_button_major__title_shm_hitalama_components_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['create_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_components_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['cancel_create'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_components_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check__aria_role_shm_hitalama_components_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['aria_role'] >
	>
	type $mol_check__checked_shm_hitalama_components_34 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__event_shm_hitalama_components_35 = $mol_type_enforce<
		({ 
			dblclick( next?: ReturnType< $shm_hitalama_components['folder_rename_start'] > ): ReturnType< $shm_hitalama_components['folder_rename_start'] >,
		})  & ReturnType< $mol_check['event'] >
		,
		ReturnType< $mol_check['event'] >
	>
	type $mol_check__sub_shm_hitalama_components_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['folder_menu_rename'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['group_add_application'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_components_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_components_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['group_add_group'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_select__dictionary_shm_hitalama_components_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['application_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_components_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['move_application'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_labeler__title_shm_hitalama_components_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_components_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Move'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_confirm_delete__title_shm_hitalama_components_47 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['title'] >
	>
	type $shm_confirm_delete__question_shm_hitalama_components_48 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_confirm_delete['question'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_components_49 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['folder_delete'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_view__sub_shm_hitalama_components_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_components_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_components_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_list__sub_shm_hitalama_components_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_guide_toggle__section_shm_hitalama_components_54 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_toggle['section'] >
	>
	type $mol_view__sub_shm_hitalama_components_55 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['group_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_hitalama_components_56 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__Anchor_shm_hitalama_components_57 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Group_title'] >
		,
		ReturnType< $mol_pick['Anchor'] >
	>
	type $mol_pick__event_shm_hitalama_components_58 = $mol_type_enforce<
		({ 
			contextmenu( next?: ReturnType< $shm_hitalama_components['folder_contextmenu'] > ): ReturnType< $shm_hitalama_components['folder_contextmenu'] >,
		})  & ReturnType< $mol_pick['event'] >
		,
		ReturnType< $mol_pick['event'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_components_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_string__value_shm_hitalama_components_60 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['folder_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_components_61 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['folder_rename_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_components_62 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_components['folder_input_pointerdown'] > ): ReturnType< $shm_hitalama_components['folder_input_pointerdown'] >,
			blur( next?: ReturnType< $shm_hitalama_components['folder_rename_submit'] > ): ReturnType< $shm_hitalama_components['folder_rename_submit'] >,
			keydown( next?: ReturnType< $shm_hitalama_components['folder_rename_keydown'] > ): ReturnType< $shm_hitalama_components['folder_rename_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $shm_hitalama_components_editor__definition_shm_hitalama_components_63 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_editor['definition'] >
	>
	type $shm_hitalama_components_menu__definition_shm_hitalama_components_64 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_menu['definition'] >
	>
	type $shm_hitalama_components_menu__versions_shm_hitalama_components_65 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Versions'] >
		,
		ReturnType< $shm_hitalama_components_menu['versions'] >
	>
	type $shm_hitalama_components_menu__drafts_shm_hitalama_components_66 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Drafts_model'] >
		,
		ReturnType< $shm_hitalama_components_menu['drafts'] >
	>
	type $shm_hitalama_components_menu__tab_shm_hitalama_components_67 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['application_tab'] >
		,
		ReturnType< $shm_hitalama_components_menu['tab'] >
	>
	type $shm_hitalama_components_versions__definition_shm_hitalama_components_68 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_versions['definition'] >
	>
	type $shm_hitalama_components_drafts_model__definition_shm_hitalama_components_69 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_drafts_model['definition'] >
	>
	type $shm_hitalama_components_drafts__model_shm_hitalama_components_70 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Drafts_model'] >
		,
		ReturnType< $shm_hitalama_components_drafts['model'] >
	>
	type $shm_hitalama_components_parameters__definition_shm_hitalama_components_71 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_parameters['definition'] >
	>
	type $shm_hitalama_components_parameters__saving_shm_hitalama_components_72 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['saving'] >
		,
		ReturnType< $shm_hitalama_components_parameters['saving'] >
	>
	type $shm_hitalama_components_parameters__save_error_shm_hitalama_components_73 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['save_status'] >
		,
		ReturnType< $shm_hitalama_components_parameters['save_error'] >
	>
	type $shm_hitalama_components_parameters__removed_shm_hitalama_components_74 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['application_removed'] >
		,
		ReturnType< $shm_hitalama_components_parameters['removed'] >
	>
	type $shm_hitalama_components_history__versions_shm_hitalama_components_75 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Versions'] >
		,
		ReturnType< $shm_hitalama_components_history['versions'] >
	>
	type $shm_hitalama_components_history__selected_shm_hitalama_components_76 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['application_version'] >
		,
		ReturnType< $shm_hitalama_components_history['selected'] >
	>
	type $shm_hitalama_components_tests__definition_shm_hitalama_components_77 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_tests['definition'] >
	>
	type $shm_hitalama_components_tests__selected_shm_hitalama_components_78 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['application_test'] >
		,
		ReturnType< $shm_hitalama_components_tests['selected'] >
	>
	type $shm_hitalama_components_tests_detail__definition_shm_hitalama_components_79 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_tests_detail['definition'] >
	>
	type $shm_hitalama_components_tests_detail__selected_shm_hitalama_components_80 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['application_test'] >
		,
		ReturnType< $shm_hitalama_components_tests_detail['selected'] >
	>
	type $shm_hitalama_components_version__entry_shm_hitalama_components_81 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['version_entry'] >
		,
		ReturnType< $shm_hitalama_components_version['entry'] >
	>
	type $shm_hitalama_components_preview__definition_shm_hitalama_components_82 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_preview['definition'] >
	>
	type $shm_hitalama_components_preview__demo_model_shm_hitalama_components_83 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['Demo_model'] >
		,
		ReturnType< $shm_hitalama_components_preview['demo_model'] >
	>
	type $shm_hitalama_components_demo__definition_shm_hitalama_components_84 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_demo['definition'] >
	>
	type $shm_hitalama_components_demo__mocked_shm_hitalama_components_85 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['demo_mocked'] >
		,
		ReturnType< $shm_hitalama_components_demo['mocked'] >
	>
	type $shm_hitalama_components_launch__definition_shm_hitalama_components_86 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['definition'] >
		,
		ReturnType< $shm_hitalama_components_launch['definition'] >
	>
	type $mol_link__arg_shm_hitalama_components_87 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components['row_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_components_88 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $shm_hitalama_components extends $mol_book2 {
		query( next?: string ): string
		sort_order( next?: string ): string
		add_enter( next?: any ): any
		add_keydown( next?: any ): any
		add_open( next?: any ): any
		Add_icon( ): $mol_icon_plus
		Add_anchor( ): $mol_button_minor
		add_content( ): readonly($mol_view)[]
		Add( ): $mol_pop_over
		catalog( ): $shm_hitalama_components_catalog
		drag_locked( ): boolean
		drag_reversed( ): boolean
		roots( ): readonly(any)[]
		children( id: any): readonly(any)[]
		expanded( id: any, next?: boolean ): boolean
		item( id: any): $mol_view
		Names( ): $shm_hitalama_components_drag
		List( ): $shm_list_page
		component_pages( ): readonly($mol_view)[]
		add_application( next?: any ): any
		Application_icon( ): $mol_icon_plus
		Add_application( ): $mol_button_minor
		add_group( next?: any ): any
		Group_icon( ): $mol_icon_folder
		Add_group( ): $mol_button_minor
		new_name_hint( ): string
		new_name( next?: string ): string
		Name( ): $mol_string
		folder_options( ): Record<string, any>
		new_parent( next?: string ): string
		Parent( ): $mol_select
		create_title( ): string
		create( next?: any ): any
		Create( ): $mol_button_major
		cancel_create( next?: any ): any
		Cancel( ): $mol_button_minor
		Create_actions( ): $mol_view
		group_content( id: any): readonly($mol_view)[]
		folder_rename_start( id: any, next?: any ): any
		Folder_icon( id: any): $mol_icon_folder
		folder_title( id: any): string
		Group_title( id: any): $mol_check
		folder_contextmenu( id: any, next?: any ): any
		folder_menu_rename( id: any, next?: any ): any
		Folder_rename( id: any): $mol_button_minor
		group_add_application( id: any, next?: any ): any
		Group_add_application( id: any): $mol_button_minor
		group_add_group( id: any, next?: any ): any
		Group_add_group( id: any): $mol_button_minor
		application_options( ): Record<string, any>
		move_application( id: any, next?: string ): string
		Move( id: any): $mol_select
		Move_label( id: any): $mol_labeler
		folder_delete( id: any, next?: any ): any
		Folder_delete( id: any): $shm_confirm_delete
		folder_draft( id: any, next?: string ): string
		folder_rename_submit( id: any, next?: any ): any
		folder_input_pointerdown( id: any, next?: any ): any
		folder_rename_keydown( id: any, next?: any ): any
		definition( ): $shm_hitalama_map_widget_entity_custom
		saving( ): ReturnType< ReturnType< $shm_hitalama_components['Editor'] >['saving'] >
		save_status( ): ReturnType< ReturnType< $shm_hitalama_components['Editor'] >['save_status'] >
		application_tab( next?: string ): string
		application_removed( next?: any ): any
		application_version( next?: string ): string
		application_test( next?: string ): string
		version_entry( ): $shm_hitalama_components_versions_entry
		demo_mocked( next?: boolean ): boolean
		row_arg( id: any): Record<string, any>
		row_title( id: any): string
		Row_name( id: any): $mol_view
		row_fqn( id: any): string
		Row_fqn( id: any): $mol_view
		menu_title( ): string
		selected( next?: string ): string
		pages( ): ReturnType< $shm_hitalama_components['component_pages'] >
		Add_menu( ): $mol_list
		Create_form( ): $mol_list
		Help( ): $shm_hitalama_guide_toggle
		create_kind( next?: string ): string
		Group_row( id: any): $mol_view
		Group( id: any): $mol_pick
		Folder_name( id: any): $mol_string
		Editor( ): $shm_hitalama_components_editor
		Menu( ): $shm_hitalama_components_menu
		Versions( ): $shm_hitalama_components_versions
		Drafts_model( ): $shm_hitalama_components_drafts_model
		Drafts( ): $shm_hitalama_components_drafts
		Parameters( ): $shm_hitalama_components_parameters
		History( ): $shm_hitalama_components_history
		Tests( ): $shm_hitalama_components_tests
		Test( ): $shm_hitalama_components_tests_detail
		Version( ): $shm_hitalama_components_version
		Preview( ): $shm_hitalama_components_preview
		Demo_model( ): $shm_hitalama_components_demo
		Launch( ): $shm_hitalama_components_launch
		Row( id: any): $mol_link
	}
	
}

//# sourceMappingURL=components.view.tree.d.ts.map